import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { finalize, tap } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { KioskManagerService } from 'src/app/services/kiosk-manager.service';
import { LocalStorageService } from 'src/app/services/local/local-storage.service';
import { EmployeeService } from 'src/app/services/repositories/employees.service';
import { PdModalComponent } from 'src/app/ui-widgets/modals/pd-modal/pd-modal.component';
import { PhotoInstructionsComponent } from 'src/app/ui-widgets/modals/photo-instructions/photo-instructions.component';

@Component({
    selector: 'app-add-photo',
    templateUrl: './add-photo.component.html',
    styleUrls: ['./add-photo.component.scss'],
    standalone: false
})
export class AddPhotoComponent implements OnInit {
  private file: File | undefined;
  private readonly N_ADD_PHOTO_WARNING_TITLE = 'Add Photo';
  private readonly N_ADD_PHOTO_WARNING_MSG = 'You must upload a photo to continue.';

  errorsModalRef: NgbModalRef | undefined;
  instructionModalRef: NgbModalRef | undefined;

  PROCESS_IMG_LOADER_ID = 'process-image-loader'
  toggleClass: boolean = true;
  isValidFile: boolean = false;
  isSubmitted: boolean = false;
  filename: string = '';
  isPhotoReady = false;
  previewImageName = '';
  employeeID: number | undefined;
  errors: any[] = [];
  isManualPD: boolean | null;
  hasPhotoUploaded: boolean = false;

  acceptableRxFormats: string[] = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/bmp'
  ];

  isKiosk = false;

  @ViewChild("errorsModal") errorsModal: TemplateRef<any> | undefined;

  employee: any;
  private modalSubscription: any;

  constructor(
    private _localStorageService: LocalStorageService,
    private _authService: AuthenticationService,
    private _employeeService: EmployeeService,
    private _loaderService: NgxUiLoaderService,
    private _router: Router,
    private _modal: NgbModal,
    private _modalService: NgbModal,
    private _notificationService: ToastrService,
    private _kioskManger: KioskManagerService
  ) {
    this.isManualPD = this._localStorageService.getManualPD();
    this.employeeID = this._authService.getUserId() || 0;
  }

  ngAfterViewInit(): void {
    this.getPD();
  }

  getPD() {
    let options: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    }
    const modalRef = this._modalService.open(PdModalComponent, options)
    modalRef.componentInstance.employeeID = this.employeeID

    this.modalSubscription = modalRef.componentInstance.onInsertNewPD
      .pipe(
        tap((size: string) => {
          (modalRef as any)._windowCmptRef.instance.size = size;
        }),
    ).subscribe();

    modalRef.result.then(() => {
      this.showIntructionsModal();
      this.isManualPD = this._localStorageService.getManualPD();
    }, () => {
      this.showIntructionsModal();
      this.isManualPD = this._localStorageService.getManualPD();
    });
  }

  showIntructionsModal() {
    this._modalService.open(PhotoInstructionsComponent,
      { size:'lg', scrollable: true, backdrop: 'static' });
  }

  ngOnInit(): void {
    this.isKiosk = this._kioskManger.isKioskMode();
  }

  validateImage() {
    if (this.file) {
      if (this.acceptableRxFormats.includes(this.file.type)) {
        this.filename = this.file.name;
        this.isValidFile = true;
      } else {
        this.isValidFile = false;
      }
    }
  }

  onFileChange(event: any) {
    if (event.target.files.length > 0) {
      this.file = event.target.files[0];
      this.validateImage();
      this.isPhotoReady = true;
    }
  }

  uploadPhoto() {
    this.isSubmitted = true;

    if (!this.isValidFile || !this.file) {
      return;
    }

    const data = new FormData();
    data.append('file', this.file, this.filename);

    if (this.isManualPD === null) {
      // TODO: Show a message that they have to select the pd type
      return;
    }

    this._loaderService.start();
    this._employeeService.uploadUserImage(this.isManualPD, data)
      .pipe(finalize(() => this._loaderService.stop()))
      .subscribe(
        (data: any) => {
          this.previewImageName = data.basename
          this.hasPhotoUploaded = true;
        },
        (err) => {
          if (err.error.context) {
            this.showErrorModal(err.error.context);
          } else {
            this.showErrorModal([{description: err.error.message}])
          }
        }
      );
  }

  showErrorModal(errors: any[]) {
    this.errors = errors;
    this.errorsModalRef = this._modal.open(this.errorsModal,
      { modalDialogClass: '', scrollable: true, backdrop: 'static' });
  }

  next() {
    if (this.hasPhotoUploaded) {
      this._router.navigate(['/sign-up/add-prescription']);
    }
    else {
      this._notificationService.warning(this.N_ADD_PHOTO_WARNING_MSG, this.N_ADD_PHOTO_WARNING_TITLE);
    }
  }

  ngOnDestroy(): void {
    if (this.modalSubscription) {
      this.modalSubscription.unsubscribe();
    }
  }

  onCloseErrorModal() {
    this.errorsModalRef?.close();
  }

}
